/**
 * @generated SignedSource<<ef8b1f776a1051bcbf3b4b7f88130633>>
 * @relayHash 1d6f341399caca91d4cefc2b1310032d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3a58d39dbe2f88ecaef1f0256876e30324404a638693467fae4527ea2e3fd7f9

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "helpCenterAri"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v2 = [{
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "helpCenterAri"
    }],
    v3 = {
      "kind": "ScalarField",
      "name": "__typename"
    },
    v4 = {
      "kind": "InlineFragment",
      "selections": [{
        "concreteType": "HelpCenterHomePageLayout",
        "kind": "LinkedField",
        "name": "homePageLayout",
        "plural": false,
        "selections": [{
          "concreteType": "HelpCenterLayoutAdf",
          "kind": "LinkedField",
          "name": "layoutAdf",
          "plural": false,
          "selections": [{
            "concreteType": "HelpCenterLayoutAdfContentConnection",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [{
              "concreteType": "HelpCenterLayoutAdfContentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [{
                "concreteType": "HelpCenterLayoutAdfContent",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "name": "content"
                }]
              }]
            }]
          }]
        }]
      }],
      "type": "HelpCenter"
    },
    v5 = {
      "kind": "InlineFragment",
      "selections": [{
        "kind": "ScalarField",
        "name": "message"
      }],
      "type": "QueryError"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "hubQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v4 /*: any*/, v5 /*: any*/]
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "hubQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v4 /*: any*/, v5 /*: any*/, {
            "kind": "InlineFragment",
            "selections": [{
              "kind": "ScalarField",
              "name": "id"
            }],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }]
    },
    "params": {
      "id": "3a58d39dbe2f88ecaef1f0256876e30324404a638693467fae4527ea2e3fd7f9",
      "metadata": {},
      "name": "hubQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "d811ca4af15968c6e4405137696fbf1d";
export default node;